
// SDK 信息
SR.data.SDKInfo = {};
// 设备信息
SR.data.deviceInfo.guid = '';
SR.data.deviceInfo.xua = '';
SR.data.deviceInfo.width = SR.dom.$win.width();
SR.data.deviceInfo.height = SR.dom.$win.height();
// 用户信息
SR.data.userInfo = {
    uid: '', // 统计、智能组合场景使用
    userAvatar: '/dist/images/avatar_placeholder.png'
}
SR.data.location = {};
SR.data.questions = []; // 当前 session 所有问题
SR.data.askAgain = []; // 当前 session 需要重问的问题，会在 visibilityChange 时进行重问操作
SR.data.xhrTimeout = 5000;
SR.data.loadingTag = 'asking';
SR.data.scrollAnimateDuration = 400;
SR.data.historyQuestionsMaxCount = 100;
SR.data.autoJumpWaitingTime = 1000;
SR.data.MAX_INTEGER = 9007199;      // 90071992547409
SR.data.alias = {
    method: 'm',
    uploadtag: 'ut',
    jsid: 'j',
    guid: 'g',
    // channelid: 'ci',
    xua: 'x',
    // ask: 'a',
    // icmd: 'i',
    opentime: 'ot',
    closetime: 'ct',
    visttime: 'vt',
    vistcount: 'vc',
    firstvist: 'fv',
    // ip: 'p',
    // domain: 'd',
    analyticsCookies: 'ac',
    cleancache: 'cc',
    uid: 'u',
    inputType: 'it',
    // timestamp: 'tp'
};
 // 客服文案
SR.data.customerServiceTip = {
    CONNECT_TIP: '正在连接人工客服，请稍候...',
    DISCONNECT_TIP: '已断开人工服务连接。',
    CONNECT_TIMEOUT_TIP: '人工服务长时间没有应答，请稍后再试。',
    DISCONNECT_ERROR_TIP: '连接人工客服超时，请重试！',
    CONNECT_ERROR_TIP: '人工客服连接出错了，请稍候再试！',
    STAFF_TITLE: '人工客服',
    CONNECTING_TIP: '人工客服接通前无法接收消息，请待接通后发消息。',
    NON_WORKING_TIME_TIP: '现在是非工作时间，请稍后再试。',
    HISTORY_TIP: '历史消息',
};

// localStorage
// localStorage.askAgainCache       // 在页面刷新后需要重问的问题缓存
// localStorage.historyQuestions    // 用户历史问题记录
// localStorage.allQuestions        // 用户全部问题记录

SR.state.isH5Mode = SR.dom.$doc.hasClass('h5-mode');
SR.state.showHistoryQuestions = true;
SR.state.isSmartRobot = SR.dom.$body.hasClass('SmartRobot');
if (SR.data.deviceInfo.isWX) {
    SR.dom.$root.addClass('WX');
}

try {
    var initLocalStroage = {};
    initLocalStroage[SR.permissions.sn] = {};
    if (localStorage.getItem('SRStorage') && localStorage.getItem('SRStorage') !== 'undefined') {
        SR.data.SRStorage = JSON.parse(localStorage.getItem('SRStorage'))
        if (!SR.data.SRStorage[SR.permissions.sn]) {
            SR.data.SRStorage[SR.permissions.sn] = {};
        }
    } else {
        SR.data.SRStorage = initLocalStroage;
    }
} catch (err) {
    console.log(err);
}
